import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { AgentDto, AiMessageDto } from '../../service/dto';
import { HttpAiAssistantService } from '../../service/http-ai-assistant.service';
import { DomSanitizer } from '@angular/platform-browser';

class MessageWrapper {
	payload!: AiMessageDto;
	content!: string;
	links!: { text: string, link: string }[];
}
@Component({
	selector: 'app-ai-chat-widget',
	standalone: false,
	templateUrl: './ai-chat-widget.component.html',
	styleUrl: './ai-chat-widget.component.scss'
})
export class AiChatWidgetComponent implements OnInit {
	private readonly STORAGE_KEY = 'poh-chat-history';
	private readonly greeting: AiMessageDto = {
		when: new Date(),
		duration: 0,
		direction: 'Received',
		message: "I'm POH",
		messageHtml: `Hello, I’m <b>POH</b>, your administrative assistant.
I can help you search for, view, and interpret information across members, claims, and complaints.
If you need details, explanations, or guidance on any record, I can provide clear and actionable answers.

How can I assist you today?`
	};
	@ViewChild('scrollContainer') private scrollContainer!: ElementRef;

	sending = false;
	outgoing = '';
	messages: MessageWrapper[] = [{ payload: this.greeting, content: this.greeting.messageHtml, links: [] }];


	constructor(private authService: AuthService, private aiService: HttpAiAssistantService, private sanitizer: DomSanitizer) {

	}
	ngOnInit(): void {
		this.loadMessages();
	}
	get authedUser(): AgentDto {
		return this.authService.authState!.agent;
	}

	send() {
		const outgoingMessage: AiMessageDto = {
			when: new Date(),
			duration: 0,
			message: this.outgoing!,
			messageHtml: '',
			direction: 'Sent'
		};
		this.sending = true;
		this.scrollToBottom();
		this.aiService.chat(outgoingMessage).subscribe({
			next: (response) => {
				const content = this.extractLinks(response.messageHtml);
				this.messages.push({ payload: outgoingMessage, content: outgoingMessage.messageHtml, links: [] });
				response.direction = 'Received';
				this.messages.push({ payload: response, content: content.html, links: content.links });
				this.persistMessages();
				this.scrollToBottom();
			},
			complete: () => {
				this.sending = false;
				this.outgoing = '';
			},
			error: () => {
				this.sending = false;
			}
		});
	}
	// extractLinks(html: string): { html: string; links: { text: string, link: string }[] } {
	// 	const links: { text: string, link: string }[] = [];

	// 	// Member links — /member/3466/view
	// 	html = html.replace(/\/member\/(\d+)\/view/g, (match) => {
	// 		links.push({ text: 'Open Member', link: match });
	// 		return ''; // remove from HTML
	// 	});

	// 	// Ticket links — /tickets/-/685
	// 	html = html.replace(/\/tickets\/-\/(\d+)/g, (match) => {
	// 		links.push({ text: 'Open Ticket', link: match });
	// 		return ''; // remove from HTML
	// 	});

	// 	return { html, links };
	// }
	extractLinks(html: string): { html: string; links: { text: string; link: string }[] } {
		const links: { text: string; link: string }[] = [];

		html = html.replace(
			/<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
			(_match, href, text) => {
				links.push({ text, link: href });
				return ''; // remove anchor from HTML
			}
		);

		return { html, links };
	}
	private scrollToBottom(): void {
		const el = this.scrollContainer.nativeElement;
		el.scrollTop = el.scrollHeight;
	}

	private persistMessages() {
		// keep only the last 20 messages
		const trimmed = this.messages.map(item => item.payload).slice(-20);

		sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(trimmed));
	}

	private loadMessages() {
		const raw = sessionStorage.getItem(this.STORAGE_KEY);
		if (!raw) return;

		try {
			const arr = JSON.parse(raw) as AiMessageDto[];
			// restore Date objects
			this.messages = arr.map(item => {
				const content = this.extractLinks(item.messageHtml);
				return { payload: item, content: content.html, links: content.links };
			});
		} catch {
			// if corrupt, clear it
			sessionStorage.removeItem(this.STORAGE_KEY);
		}
	}
}
